export const getLocalFireInfoSchema = {
    'forecasts[]': {
        'dayOfWeekLocal': 'dwl',
        'dayOfWeekAbbreviatedLocal': 'dwal',
        'fireRiskIndex': 'fri',
        'fireRiskDescriptionLong': 'frdl',
        'fireRiskDescriptionShort': 'frds',
        'fireRiskReasons[]': {
            'reasonText': 'rt',
            'objectMapperKey': 'frrs'
        },
        'objectMapperKey': 'f'
    },
    'closestFire': {
        'distance': 'cf.d',
        'distanceUnit': 'cf.du',
        'centerLatitude': 'cf.clat',
        'centerLongitude': 'cf.clon',
        'formattedDistanceStr': 'cf.fds'
    },
    'fireMessage': 'fm',
    'lastUpdatedDateTime': 'ludt'
};
